import { jsPDF } from 'jspdf'

// const loadFont = async (url: string) => {
//   const response = await fetch(url)
//   const arrayBuffer = await response.arrayBuffer()
//   const uint8Array = new Uint8Array(arrayBuffer)
//   const binaryString = uint8Array.reduce((data, byte) => data + String.fromCharCode(byte), '')
//   return btoa(binaryString) // Převod na Base64
// }

export const generatePdf = async (submitResponseTitle: string, submitResponseTime: string, contractName: string, contractLink: string, infoText?: string) => {
  const doc = new jsPDF()

  // const fontBase64 = await loadFont('/Roboto-Regular.ttf');

  // doc.addFileToVFS("Roboto-Regular.ttf", fontBase64)
  doc.addFont('/Roboto-Regular-ekompdf.ttf', 'Roboto-Regular', 'normal') // zdroj z /public v projektu PoDo
  doc.setFont('Roboto-Regular')

  // const imageUrl = "/apple-touch-icon.png";
  const imageUrl = '/favicon-32x32.png'
  doc.addImage(imageUrl, 'PNG', 10, 10, 16, 16)// Pozice a velikost loga (x, y, width, height)

  doc.setFontSize(18)
  doc.text('eKomunikace | Portál Dodavatele', 50, 20)  // Posun od loga (pozice x, y)
  doc.setFontSize(20)
  doc.text(submitResponseTitle, 10, 50)
  doc.setFontSize(14)
  doc.text(`Datum a čas doručení:`, 10, 70)
  doc.text(submitResponseTime, 10, 80)
  doc.text(`Zadávací postup:`, 10, 100)
  doc.text(doc.splitTextToSize(contractName, 180), 10, 110)
  doc.setFontSize(12)
  doc.text(doc.splitTextToSize(contractLink, 180), 10, 120)
  if (infoText) {
    doc.setFontSize(12)
    doc.text(infoText, 10, 140)
  }
  // Uložit soubor
  doc.save('ekomunikace_potvrzeni_podani.pdf')
}
